import { Routes } from '@angular/router';
import { AccountsVerifiedGuard } from './accounts/guards/verified.guard';
import { CustomerExistsGuard } from './customers';
import { FeatureFlagGuard } from './shared/guards/feature.guard';
import { Auth0Guard } from '@geneplanet/ngx-auth0';

import { MobileGuard } from './core/guards/mobile.guard';
import { canActivateFeature } from './shared/guards/feature-active.guard';

export const routes: Routes = [
  {
    path: 'me',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./me/routes').then((m) => m.routes),
  },
  {
    path: 'healthscore',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./healthscore/routes').then((m) => m.routes),
  },
  {
    path: 'prs',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./prs/routes').then((m) => m.routes),
  },
  {
    path: 'accounts',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./accounts/routes').then((m) => m.routes),
  },
  {
    canActivate: [FeatureFlagGuard],
    path: 'microbiome',
    loadChildren: () =>
      import('./oral-microbiome/routes').then((m) => m.routes),
    data: { feature: 'oralMicrobiome' },
  },
  {
    path: 'dashboard',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./dashboard/routes').then((m) => m.routes),
  },

  {
    path: 'foodid',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./foodid/routes').then((m) => m.routes),
  },
  {
    path: 'nipt',
    data: { feature: 'nipt', skipRouteLocalization: true },
    loadChildren: () => import('./nipt/routes').then((m) => m.routes),
    canActivateChild: [FeatureFlagGuard],
  },
  {
    path: 'onboarding',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./onboarding/routes').then((m) => m.routes),
  },
  {
    path: 'ancestry',
    canActivateChild: [
      Auth0Guard,
      AccountsVerifiedGuard,
      CustomerExistsGuard,
      FeatureFlagGuard,
    ],
    data: { feature: 'ancestry', skipRouteLocalization: true, noPreload: true },
    loadChildren: () => import('./ancestry/routes').then((m) => m.routes),
  },
  {
    path: '',
    data: { skipRouteLocalization: { localizeRedirectTo: true } },
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    data: { skipRouteLocalization: true },
    path: '',
    canActivateChild: [
      AccountsVerifiedGuard,
      CustomerExistsGuard,
      canActivateFeature('shop', '/error/shop-unavailable'),
    ],
    loadChildren: () =>
      import('@geneplanet/ngx-shop/src/lib/shop').then((m) => m.ShopModule),
  },
  {
    path: 'habits',
    data: { skipRouteLocalization: true },
    canActivateChild: [Auth0Guard, AccountsVerifiedGuard, CustomerExistsGuard],
    loadChildren: () => import('./habits/routes').then((m) => m.routes),
  },
  {
    path: 'blood',
    canActivateChild: [Auth0Guard, AccountsVerifiedGuard, CustomerExistsGuard],
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./blood/routes').then((m) => m.BLOOD_ROUTES),
  },
  {
    path: 'measurement',
    data: { skipRouteLocalization: true },
    canActivateChild: [CustomerExistsGuard],
    loadChildren: () =>
      import('./body-measurements/routes').then((m) => m.routes),
  },
  {
    path: 'dna',
    data: { skipRouteLocalization: true },
    canActivateChild: [Auth0Guard, CustomerExistsGuard],
    loadChildren: () => import('./dna/routes').then((m) => m.routes),
  },
  {
    path: 'dna-snp',
    data: { skipRouteLocalization: true },
    canActivateChild: [Auth0Guard, CustomerExistsGuard],
    loadChildren: () => import('./dna-snp/routes').then((m) => m.routes),
  },
  {
    path: 'recipes',
    data: { skipRouteLocalization: true },
    canActivateChild: [Auth0Guard, AccountsVerifiedGuard, CustomerExistsGuard],
    loadChildren: async () => (await import('./recipes/routes')).routes,
  },
  {
    path: 'meal-analyser',
    data: { skipRouteLocalization: true },
    canActivateChild: [Auth0Guard, AccountsVerifiedGuard, CustomerExistsGuard],
    loadChildren: async () => (await import('./meal-analyser/routes')).routes,
  },
  {
    path: 'error',
    data: { skipRouteLocalization: true },
    loadChildren: () => import('./error/routes').then((m) => m.routes),
  },
  {
    path: 'results',
    data: {
      skipRouteLocalization: true,
      layout: {
        sideMenu: {
          hide: true,
        },
      },
    },
    canActivate: [MobileGuard, Auth0Guard],
    loadComponent: () =>
      import('./core/pages').then((m) => m.ResultsMenuComponent),
  },
  {
    path: 'add-data',
    data: {
      skipRouteLocalization: true,
      layout: {
        sideMenu: {
          hide: true,
        },
      },
    },
    canActivate: [MobileGuard, Auth0Guard],
    loadComponent: () =>
      import('./core/pages').then((m) => m.AddDataMenuComponent),
  },
  {
    path: '**',
    redirectTo: '/dashboard',
    data: { skipRouteLocalization: true },
  },
];
